import { useEffect, useRef } from 'react';
import { handleClickOutside } from 'utils/helpers/chatbotHelpers';

export const useModalInteractions = (
  isOpen: boolean,
  onClose: () => void,
  messages: any[],
  resetAutocomplete: () => void
) => {
  const chatAreaRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chatAreaRef.current) {
      chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    const handleClickOutsideEvent = (event: MouseEvent) => {
      handleClickOutside(event, isOpen, popupRef, onClose, resetAutocomplete);
    };

    const handleModalClick = (event: MouseEvent) => {
      const target = event.target as Node;
      const autocompleteDropdown = document.querySelector(
        '[data-autocomplete-dropdown]'
      );

      if (
        isOpen &&
        popupRef.current &&
        popupRef.current.contains(target) &&
        !autocompleteDropdown?.contains(target)
      ) {
        resetAutocomplete();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutsideEvent);
      document.addEventListener('mousedown', handleModalClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideEvent);
      document.removeEventListener('mousedown', handleModalClick);
    };
  }, [isOpen, onClose, resetAutocomplete]);

  return {
    chatAreaRef,
    popupRef
  };
};
